import { render } from "./SearchFilter.vue?vue&type=template&id=20ffa8a9"
import script from "./SearchFilter.vue?vue&type=script&lang=js"
export * from "./SearchFilter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/mwon.net/gugar.mwon.net/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__